<h2 mat-dialog-title>Terms of Services Agreement</h2>
<mat-dialog-content class="mat-typography">
	<pdf-viewer (after-load-complete)="onScroll()" src="/assets/Direct-to-Consumer-SREC-Contract.pdf"
		[render-text]="true" [original-size]="false" style="width: 100%; height: 100%"></pdf-viewer>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button [mat-dialog-close]="true" [disabled]="!isTermsRead">Accept</button>
</mat-dialog-actions>